export const ATTACHMENT_MAX_FILES = 3;
export const ATTACHMENT_MAX_SIZE_BYTES = 10 * 1024 * 1024;
export const ATTACHMENT_ACCEPTED_TYPES = [
	'image/bmp',
	'image/gif',
	'image/heif',
	'image/heic',
	'image/jpeg',
	'image/jpg',
	'image/png',
	'image/tiff'
];
// Note (Ben): include common extensions explicitly — some browsers leave file.type
// blank for HEIF/HEIC/TIFF, but the file picker `accept` attribute still filters by
// extension fallback. Validation in useAttachmentUpload also falls back to extension.
export const ATTACHMENT_ACCEPT_ATTR = [
	...ATTACHMENT_ACCEPTED_TYPES,
	'.bmp',
	'.gif',
	'.heif',
	'.heic',
	'.jpg',
	'.jpeg',
	'.png',
	'.tif',
	'.tiff'
].join(',');
export const ATTACHMENT_ACCEPTED_EXTENSIONS = [
	'.bmp',
	'.gif',
	'.heif',
	'.heic',
	'.jpg',
	'.jpeg',
	'.png',
	'.tif',
	'.tiff'
];

export type AttachmentStatus = 'uploading' | 'success' | 'error';

export type DcrAttachment = {
	id: string;
	name: string;
	size: number;
	mimeType: string;
	previewUrl: string;
	status: AttachmentStatus;
	progress: number;
	error?: string;
	remoteId?: string;
};
